import * as React from 'react';
import * as ReactDOM from 'react-dom';
import OSM from '../ts/ol/source/OSM.js';
import TileLayer from '../ts/ol/layer/Tile.js';
import View from '../ts/ol/View.js';
import Map from '../ts/ol/Map.js';
import { addCoordinateTransforms, addProjection, transform } from '../ts/ol/proj.js';
var scriptjs = require('scriptjs');
class GisPreview extends React.Component<
    {
        theme;
        glob;
    },
    any
> {
    private static GOOGLE_MAPS_URL = 'https://maps.googleapis.com/maps/api/js?key=';
    private static DEFAULT_GOOGLE_MAPS_KEY = 'AIzaSyBsKhwXHQQizvKzFNSF33zMJsfgNKvjB2Y';
    private gmap;
    private map;
    private references: {
        olmap?: HTMLDivElement;
        map?: HTMLDivElement;
        gmap?: HTMLDivElement;
        divlayers?: HTMLDivElement;
        container?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
        this.state = {
            theme: this.props.theme
        };
    }

    initMap = () => {
        if (this.references == null) {
            return;
        }
        const _map = this.references.map;
        const gmap_container = this.references.gmap;

        var GISservice = this.props.theme['widget-gis-map'];

        var view = new View({
            zoom: 2,
            center: [0, 0],
            projection: 'EPSG:3857'
        });
        let self = this;
        view.on('change:center', function () {
            //LonLat
            var center = transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');

            if (GISservice.GIS_service == 'GoogleMap' && self.gmap && google) {
                if (!isNaN(center[1]) && !isNaN(center[0])) {
                    self.gmap.setCenter(new google.maps.LatLng(center[1], center[0]));
                }
                self.gmap.setZoom(view.getZoom());
            }
        });
        view.on('change:resolution', function () {
            self.setState({
                zoom: view.getZoom()
            });
            if (GISservice.GIS_service == 'GoogleMap' && self.gmap) {
                self.gmap.setZoom(view.getZoom());
            }
        });
        if (GISservice.GIS_service == 'GoogleMap' && google) {
            var mapOptions = {
                backgroundColor: 'ffffff',
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                keyboardShortcuts: false,
                draggable: false,
                disableDoubleClickZoom: true,
                scrollwheel: false,
                styles: [
                    {
                        featureType: 'water',
                        stylers: [
                            { color: GISservice.water_color } // applying map water color
                        ]
                    },
                    {
                        featureType: 'landscape.natural',
                        stylers: [{ color: GISservice.landscape_color }]
                    }
                ]
            };
            if (gmap_container) {
                this.gmap = new google.maps.Map(gmap_container, mapOptions as google.maps.MapOptions);
            }
        }
        if (GISservice?.GIS_service !== 'GoogleMap' && this.gmap && google) {
            this.gmap.controls[google.maps.ControlPosition.RIGHT_TOP].clear();
        }
        var olmap = document.getElementById('olmap_preview');
        if (olmap) {
            olmap.parentNode.removeChild(olmap);
        }
        $(_map).append('<div id="olmap_preview" class="MaxSize"></div>');

        if (GISservice?.GIS_service == 'GoogleMap' && this.gmap && google) {
            var olmap = document.getElementById('olmap_preview');
            this.gmap.controls[google.maps.ControlPosition.TOP_LEFT].push(olmap);
            google.maps.event.trigger(this.gmap, 'resize');
        }

        this.map = new Map({
            layers: [
                new TileLayer({
                    source: new OSM()
                })
            ],
            target: 'olmap_preview',
            view: view
        });
        this.setMapPosition();
        //this.resize();
        if (this.map) {
            this.map.updateSize();
        }
    };

    private resize = () => {
        var map = this.map;
        var gmap = this.gmap;
        if (map != null) {
            map.updateSize();
            if (gmap != null && google) {
                var view = map.getView();
                if (view.getCenter()) {
                    var center = transform(view.getCenter(), 'EPSG:3857', 'EPSG:4326');
                    google.maps.event.trigger(gmap, 'resize');
                    if (!isNaN(center[1]) && !isNaN(center[0])) {
                        gmap.setCenter(new google.maps.LatLng(center[1], center[0]));
                    }
                    gmap.setZoom(view.getZoom());
                }
            }
        }
    };

    private setMapPosition() {
        const widgetGISPosition = this.props.theme['widget-gis-position'];
        var map = this.map;
        var self = this;
        if (map && typeof map.getView == 'function') {
            var view = map.getView();

            if (view) {
                if (!isNaN(widgetGISPosition.latitude) && !isNaN(widgetGISPosition.longitude)) {
                    view.setCenter([widgetGISPosition.latitude, widgetGISPosition.longitude]);
                }
                view.setZoom(widgetGISPosition.zoom);

                if (widgetGISPosition.center == 'CenterManually') {
                    var cnt = transform(
                        [widgetGISPosition.longitude, widgetGISPosition.latitude],
                        'EPSG:4326',
                        'EPSG:3857'
                    );
                    if (!isNaN(cnt[0]) && !isNaN(cnt[1])) {
                    }
                    view.setCenter([cnt[0], cnt[1]]);

                    view.setZoom(widgetGISPosition.zoom);
                } else if (widgetGISPosition.center == 'CenterToMyLocation') {
                    var geo_options = {
                        enableHighAccuracy: true,
                        maximumAge: 30000,
                        timeout: 27000
                    };

                    if ('geolocation' in navigator) {
                        navigator.geolocation.getCurrentPosition(
                            function (position) {
                                console.log(position.coords.latitude, position.coords.longitude);
                                var cnt = transform(
                                    [position.coords.longitude, position.coords.latitude],
                                    'EPSG:4326',
                                    'EPSG:3857'
                                );
                                if (!isNaN(cnt[0]) && !isNaN(cnt[1])) {
                                    view.setCenter([cnt[0], cnt[1]]);
                                }
                                view.setZoom(widgetGISPosition.zoom);
                            },
                            function (err) {
                                console.log('Geolocation for map centering is unavailable. ', err.message);
                                self.props.glob.AppActions.notification(
                                    'warning',
                                    'Geolocation for map centering is unavailable. ' + err.message
                                );
                            },
                            geo_options
                        );
                    } else {
                        console.log('Geolocation for map centering is unavailable.');
                        this.props.glob.AppActions.notification(
                            'warning',
                            'Geolocation for map centering is unavailable.'
                        );
                    }
                } else {
                    var cnt = transform([0, 0], 'EPSG:4326', 'EPSG:3857');
                    if (!isNaN(cnt[0]) && !isNaN(cnt[1])) {
                    }
                    view.setCenter([cnt[0], cnt[1]]);
                    view.setZoom(1);
                }
            }
        }
    }

    componentDidMount() {
        this.loadGoogleGetData();
        $(window).on('resize', this.resize);
        const container = this.references.container;
        if (container) {
            $(container).on('resize', this.resize);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            JSON.stringify(this.props.theme['widget-gis-map']) !== JSON.stringify(prevProps.theme['widget-gis-map']) ||
            JSON.stringify(this.props.theme['widget-gis-position']) !==
                JSON.stringify(prevProps.theme['widget-gis-position'])
        ) {
            this.loadGoogleGetData();
        }
    }

    componentWillUnmount() {
        if (this.map) {
            this.map = null;
        }

        $(window).off('resize', this.resize);
        const container = this.references.container;
        if (container) {
            $(container).off('resize');
        }
    }

    private loadGoogleMap() {
        var GISservice = this.props.theme['widget-gis-map'];
        let _loadGoogleMap = GISservice.GIS_service === 'GoogleMap';

        if (_loadGoogleMap) {
            const scripts = document.getElementsByTagName('script');
            if (scripts != null) {
                for (let i = 0; i < scripts.length; i++) {
                    const script = scripts[i];
                    const src = script.src;

                    if (src.indexOf(GisPreview.GOOGLE_MAPS_URL) === 0) {
                        _loadGoogleMap = false;
                        break;
                    }
                }
            }
        }
        return _loadGoogleMap;
    }

    private loadGoogleGetData = () => {
        let googleMapAPIKey = this.props.theme['widget-gis-google-api-key'];
        let _loadGoogleMap = this.loadGoogleMap();
        if (_loadGoogleMap) {
            const key =
                googleMapAPIKey != null && googleMapAPIKey !== ''
                    ? googleMapAPIKey
                    : GisPreview.DEFAULT_GOOGLE_MAPS_KEY;
            const googleUrl = GisPreview.GOOGLE_MAPS_URL + key;

            scriptjs([googleUrl], this.initMap);
        } else {
            this.initMap();
        }
    };

    render() {
        var divgmap;
        var GISservice = this.props.theme['widget-gis-map'];
        if (GISservice.GIS_service == 'GoogleMap') {
            divgmap = (
                <div
                    id={'gmap'}
                    ref={(input) => {
                        this.references.gmap = input;
                    }}
                    className="MaxSize"
                />
            );
        }
        return (
            <div
                id="pdc-widget-gis"
                className="MaxSize"
                ref={(input) => {
                    this.references.container = input;
                }}
            >
                <div id="mapdiv" className="MaxSize">
                    <div
                        ref={(input) => {
                            this.references.map = input;
                        }}
                        id="map"
                        className="MaxSize"
                        style={{ borderRadius: '0 0 10px 10px' }}
                    >
                        {divgmap}
                    </div>
                </div>
            </div>
        );
    }
}

//exports = function (glob, theme) {
export function ThemePreview(glob, theme) {
    var className: string = 'invisible';
    if (theme['widget-gis-show-layers'] == true) {
        className = 'visible';
    }
    return [
        <div key="widget-inner-container" className="widget pdc-widget-gis-config" style={{ height: '90%' }}>
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>GIS Widget</span>
                    <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                    <span className="glyphicon glyphicon-cog config-button header-button"></span>
                    <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-clock">
                        <div className="MaxSize">
                            <GisPreview theme={theme} glob={glob} />
                        </div>
                        <span className={className + ' layerPanel'}>Layer panel</span>
                    </div>
                </div>
            </div>
        </div>
    ];
}

